enum AnswersTabs {
  Answers = 'answers',
  AdditionalAnswers = 'additionalAnswers'
};

export default AnswersTabs;
